export const PRIMARY_COLOR = '#0D47C8';
export const PRIMARY_CONTROL_OUTLINE = 'rgba(13, 71, 200, 0.12)';
